
  <!-- Author: lss@ies. Html doc and Css style locked. -->
  <!-- このドキュメントを個人的に変更することは固く禁じられています。一度変更すると、サポートは提供しません。 -->

<template>
  <main-layout>

    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-13" />
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t("title.system.area.title") }}</label>
        <narrow-down
          slot="create"
          @click="areaBuilding"
          v-auth="{ auth: '010502'}">
          {{ $t("label.system.area.search.areaCreate") }}
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">

      <!-- 検索パネル -->
      <div class="panel-search">

        <el-form
          :model="query"
          :rules="rules"
          ref="ruleForm"
          class="search-form"
          label-position="left">

          <!-- オーナーID/オーナー名 -->
          <div class="fm-row">
            <el-form-item
              prop="ownerExId"
              class="el-form-item-input margin-right-20">
              <el-input
                maxlength="20"
                class="fm-input"
                v-model="query.ownerExId"
                :placeholder="
                      $t('label.system.area.search.ownerId') +
                      $t('label.system.owner.search.prompt.prefixMatchBrackets')
                ">
              </el-input>
            </el-form-item>

            <label-button class="fm-lb-btn line-limit-length" v-show="query.ownerName">
              {{ query.ownerName }}
            </label-button>

            <button-index @click="selectOwner" class="fm-st-btn limit-length">
              {{ $t("button.common.select") }}
            </button-index>
          </div>

          <!-- ビルID/ビル名 -->
          <div class="fm-row">
            <el-form-item
              prop="buildingExId"
              class="el-form-item-input">
              <el-input
                maxlength="20"
                class="fm-input"
                v-model="query.buildingExId"
                :placeholder="
                    $t('label.system.area.search.buildingId') +
                    $t('label.system.owner.search.prompt.partialMatchs')
                "/>
            </el-form-item>

            <label-button class="fm-lb-btn line-limit-length" v-show="query.buildingName">
              {{ query.buildingName }}
            </label-button>

            <button-index @click="selectBuilding" class="fm-st-btn limit-length">
              {{ $t("button.common.select") }}
            </button-index>
          </div>

          <!-- フロア -->
          <div class="fm-row">

            <el-form-item
              size="small"
              prop="floor"
              class="el-form-item-input"
            >
              <el-input
                maxlength="50"
                :readonly="true"
                v-model="query.floor"
                class="fm-input"
                :placeholder="$t('label.system.area.search.floorSearch')"
              />
            </el-form-item>

            <button-index @click="selectFloor" class="fm-st-btn limit-length">
              {{$t("button.common.select") }}
            </button-index>
          </div>

          <!-- エリア名、エリア区分 -->
          <div class="fm-row">
            <!-- エリア名 -->
            <el-form-item prop="areaName" class="el-form-item-input">
              <el-input
                class="fm-input"
                maxlength="50"
                v-model="query.areaName"
                :placeholder="$t('label.common.areaNamePlaceHolder')" />
            </el-form-item>

            <!-- エリア区分 -->
            <el-form-item prop="areaType">
              <el-select
                class="fm-select"
                v-model="query.areaType"
                :placeholder="$t('label.system.area.search.areaTypeSelect')">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in areaTypeOptions" />
              </el-select>
            </el-form-item>
          </div>

          <!-- ボタンエリア -->
          <div class="fm-row btn-area">
            <narrow-down @click="searchArea">
              {{$t('button.system.owner.search.search')}}
            </narrow-down>
            <cancel-narrow-down class="link-primary margin-left-8" @click="clearSearchParams">
              {{$t('button.system.owner.search.clear')}}
            </cancel-narrow-down>
            <narrow-down
              v-auth="{ auth:'010508' }"
              class="download-btn"
              @click="download">
              {{ $t("button.system.account.search.csvDownload") }}
            </narrow-down>
            <!-- v-auth="{ auth: '010101' }" -->
            <narrow-down
              v-auth="{ auth:'010509' }"
              class="download-btn"
              style="margin-left: 20px;"
              @click="upload">
              {{ $t("button.system.account.search.csvUpload") }}
            </narrow-down>
          </div>
        </el-form>

      </div>

      <!-- ページサイズ選択 -->
      <label v-show="isShow" class="list-title">{{ $t("title.system.area.search") }}</label>
      <div class="text-right" v-show="isShow">
        <label class="label-right lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select
          class="zdyselect"
          @change="changePageSize"
          v-model="query.pageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>

      <!-- 検索結果テーブル -->
      <div ref="searchResultTable" id="search-result" class="margin-top-28">
        <area-search-result-beautify
          :isShow="isShow"
          :result="searchResult.content"
          @on-delete="deleteArea"
          @on-detail="detailArea"
          @on-edit="editArea" />
      </div>

      <br>

      <!--  分页 開始  -->
      <div class="text-center">
        <pagination
          v-show="pagingShow"
          :totalCount="searchResult.totalCount"
          :totalPage="searchResult.totalPage"
          :pageSize="query.pageSize"
          :pageNumber="searchResult.pageNumber"
          @on-paging="handlePagingAction" />
      </div>

      <!-- オーナー選択名ポップアップ  -->
      <owner-search-popup
        :ownerExIdParam="query.ownerExId"
        :ownerNameParam="query.ownerName"
        :visible.sync="showSelectOwnerDialog"
        @on-selected="handlerOwnerSelected" />

      <!-- ビル名選択ポップアップ  -->
      <building-search-popup
        :ownerIdParam="query.ownerId"
        :buildingExIdParam="query.buildingExId"
        :buildingNameParam="query.buildingName"
        :visible.sync="showSelectBuildingDialog"
        @on-selected="handlerBuildingSelected" />

      <!-- フロア選択ポップアップ -->
      <floor-search-popup
        :ownerIdParam="query.ownerId"
        :ownerExIdParam="query.ownerExId"
        :ownerNameParam="query.ownerName"
        :buildingIdParam="query.buildingId"
        :buildingExIdParam="query.buildingExId"
        :buildingNameParam="query.buildingName"
        :floorIdParam="query.floorId"
        :floorNameParam="query.floor"
        :visible.sync="showSelectFloorDialog"
        @on-selected="handlerFloorSelected" />

      <file-downloader-loading-dialog :dialogVisible="showLoading" />
  </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import AreaSearchResultBeautify from "@/components/system/AreaSearchResultBeautify";
import Pagination from "@/components/common/pagination/Pagination";
import SystemManageApi from "@/api/SystemManageApi";
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup";
import BuildingSearchPopup from "@/components/system/popup/BuildingSearchPopup";
import FloorSearchPopup from "@/components/system/popup/FloorSearchPopup";
import AreaSearchRuleFactory from "@/rules/rule-area-search";
import headTitle from "@/components/common/head/head"
import Menubar from "@/components/leftmenu/DashBoard"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import buttonIndex from "@/components/common/sp-smart-button/index";
import labelButton from "@/components/common/sp-smart-lable-button/index";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import fileDownloader from "@/utils/file-downloader";
import FileDownloaderLoadingDialog from "@/components/common/loading/FileDownloaderLoadingDialog"

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

export default {
  name: "AreaSearch",
  components: {
    MainLayout: NewDesignLayout,
    AreaSearchResultBeautify: AreaSearchResultBeautify,
    Pagination: Pagination,
    OwnerSearchPopup: OwnerSearchPopup,
    BuildingSearchPopup: BuildingSearchPopup,
    FloorSearchPopup: FloorSearchPopup,
    labelButton: labelButton,
    buttonIndex: buttonIndex,
    Menubar: Menubar,
    headTitle,
    cancelNarrowDown,
    narrowDown,
    FileDownloaderLoadingDialog
  },
  data() {
    return {
      showLoading:false,
      isShow: false,
      areaTypeOptions: [
        {
          value: null,
          label: "",
        },
        {
          value: "01",
          label: this.$t("label.system.area.search.areaTypeOptions.value1"),
        },
        {
          value: "02",
          label: this.$t("label.system.area.search.areaTypeOptions.value2"),
        },
        {
          value: "03",
          label: this.$t("label.system.area.search.areaTypeOptions.value3"),
        },
        {
          value: "04",
          label: this.$t("label.system.area.search.areaTypeOptions.value4"),
        },
      ],
      //照会条件宣言
      query: {
        ownerExId: null,
        ownerName: null,
        ownerId: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floor: null,
        floorId: null,
        areaType: null,
        areaName: null,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
      },
      //結果宣言に戻る
      searchResult: {
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalPage: 0,
        totalCount: 0,
        content: [
        ],
        ownerExId: "",
      },
      options: [
        {
          label: "10件",
          value: 10,
        },
        {
          label: "20件",
          value: 20,
        },
        {
          label: "50件",
          value: 50,
        },
      ],
      isSearching: false,
      tableLoadingAnim: null,
      showSelectOwnerDialog: false,
      showSelectBuildingDialog: false,
      showSelectFloorDialog: false,
      rules: AreaSearchRuleFactory.areaSearchRules(this),
    };
  },
  computed: {
    pagingShow() {
      return this.searchResult.content.length > 0;
    }
  },
  methods: {
    //検索
    searchArea() {
      this.$saveQueryParam("area_search_id", this.query)
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.isSearching) {
            this.isShow = true;
            this.isSearching = true;
            this.showTableLoadingAnim();
            this.searchResult.content = [];
            SystemManageApi.searchArea({
              ownerId: this.query.ownerId,
              ownerExId: this.query.ownerExId,
              ownerName: this.query.ownerName,
              buildingId: this.query.buildingId,
              buildingExId: this.query.buildingExId,
              buildingName: this.query.buildingName,
              floorId: this.query.floorId,
              areaType: this.query.areaType,
              areaName: this.query.areaName,
              pageSize: this.query.pageSize,
              pageNumber: this.query.pageNumber,
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
              .then(({ data }) => {
                if(!statusErrorCodeMsg(data.statusCode, this)) {
                  return;
                }
                this.searchResult.pageNumber = data.body.pageNumber;
                this.searchResult.pageSize = data.body.pageSize;
                this.searchResult.totalPage = data.body.totalPage;
                this.searchResult.totalCount = data.body.totalCount;
                for (let index of data.body.body) {
                  this.searchResult.content.push({
                    deleteFlag: index.deleteFlag,
                    areaId: index.areaId,
                    areaName: index.areaName,
                    floorName: index.floorName,
                    areaType: index.areaType,
                    adress:
                      index.ownerName +
                      "  :  " +
                      index.buildingName +
                      "    " +
                      index.floorName,
                  });
                }
              })
              .finally(() => {
                this.isSearching = false;
                this.hideTableLoadingAnim();
              });
          }
        } else {
          return false;
        }
      });
    },
    //クリア
    clearSearchParams: function () {
      this.$saveQueryParam("area_search_id", null)
      this.query.ownerExId = null;
      this.query.ownerName = null;
      this.query.ownerId = null;
      this.query.buildingId = null;
      this.query.buildingExId = null;
      this.query.buildingName = null;
      this.query.pageSize = DEFAULT_PAGE_SIZE;
      this.query.pageNumber = DEFAULT_PAGE_NUMBER;
      this.query.floor = null;
      this.query.floorId = null;
      this.query.areaType = null;
      this.query.areaName = null;
      this.searchResult.totalPage = 0;
      this.searchResult.totalCount = 0;
      this.searchResult.content = [];
      this.isShow = false;
    },
    //削除バータン
    deleteArea(areaId, index) {
      this.showTableLoadingAnim();
      SystemManageApi.deleteArea(areaId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({data}) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          let owners = this.searchResult.content;
          owners.splice(index, 1);
          this.deleteSuccess();
        })
        .finally(() => {
          this.hideTableLoadingAnim();
        });
    },

    changePageSize(){
      this.query.pageNumber = 1
      this.searchArea()
    },
    //照会バータン
    detailArea(areaId) {
      this.$saveQueryParam("area_search_id", this.query)
      this.$router.push({
        name: "system-area-detail",
        params: {
          areaId: areaId,
        },
      });
    },
    //編集バータン
    editArea(areaId) {
      this.$saveQueryParam("area_search_id", this.query)
      this.$router.push({
        name: "system-area-edit",
        params: {
          areaId: areaId,
        },
      });
    },
    //表示テーブルに動画をロードする
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#search-result",
          background: "#ebebe6"
        });
      }
    },
    //隠しフォームロードアニメーション
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },
    //ページ分け事件を処理する
    handlePagingAction(paging) {
      this.query.pageSize = paging.pageSize;
      this.query.pageNumber = paging.pageNumber;
      this.searchArea()
      this.$refs.searchResultTable.scrollIntoView()
    },
    //オーナーサブ画面の選択
    selectOwner() {
      this.showSelectOwnerDialog = true;
    },
    //ビルサブ画面の選択
    selectBuilding() {
      this.showSelectBuildingDialog = true
    },
    //フロアサブ画面の選択
    selectFloor() {
      this.showSelectFloorDialog = true;
    },
    handlerOwnerSelected(owner) {
      if (this.query.ownerId != owner.id) {
        this.query.buildingId = null
        this.query.buildingExId = null
        this.query.buildingName = null
        this.query.floorId = null
        this.query.floor = null
      }
      this.query.ownerId = owner.id;
      this.query.ownerName = owner.name;
      this.query.ownerExId = owner.exId;
    },
    handlerBuildingSelected(building) {
      if ( this.query.buildingId != building.buildingId) {
        this.query.floorId = null
        this.query.floor = null
      }
      this.query.ownerId = building.ownerId;
      this.query.ownerName = building.ownerName;
      this.query.ownerExId = building.ownerExId;
      this.query.buildingName = building.buildingName;
      this.query.buildingExId = building.buildingExId;
      this.query.buildingId = building.buildingId;
    },
    handlerFloorSelected(floor) {
      this.query.ownerId = floor.ownerId;
      this.query.ownerName = floor.ownerName;
      this.query.ownerExId = floor.ownerExId;
      this.query.buildingName = floor.buildingName;
      this.query.buildingExId = floor.buildingExId;
      this.query.buildingId = floor.buildingId;
      this.query.floor = floor.floorName;
      this.query.floorId = floor.floorId;
    },
    //ビル新規
    areaBuilding() {
      this.$saveQueryParam("area_search_id", this.query)
      this.$router.push({
        name: "system-area-create",
      });
    },
    checkSearchConditions: function (query) {
      let isPast = false;
      if (
        (query.ownerEXId != "" ||
          query.ownerName != "" ||
          query.buildingEXId != "" ||
          query.buildingName != "" ||
          query.floor != "" ||
          query.areaName != "" ||
          query.areaType != "") &&
        (query.ownerEXId != null ||
          query.ownerName != null ||
          query.buildingEXId != null ||
          query.buildingName != null ||
          query.floor != null ||
          query.areaName != null ||
          query.areaType != null)
      ) {
        isPast = true;
      }
      return isPast;
    },
    //削除成功Message
    deleteSuccess: function () {
      this.$messageIotSuccess(this.$t("message.system.area.deleteSuccess"));
    },
    download() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
        this.showLoading = true;
        SystemManageApi.batchExport({
          ownerId: this.query.ownerId,
          ownerExId: this.query.ownerExId,
          ownerName: this.query.ownerName,
          buildingId: this.query.buildingId,
          buildingExId: this.query.buildingExId,
          buildingName: this.query.buildingName,
          floorId: this.query.floorId,
          areaType: this.query.areaType,
          areaName: this.query.areaName,
        }, '03')
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(( data ) => {
            this.showLoading = false;

            const blob = data.data;

            // レスポンスの Content-Type が application/json の場合
            // → ファイルではなくエラー情報（JSON）が返却されている可能性がある
            if (blob.type && blob.type.includes('application/json')) {

              // Blob データを文字列に変換
              blob.text().then(text => {

                // JSON 文字列をオブジェクトに変換
                const json = JSON.parse(text);

                // エラーメッセージおよびダウンロード上限数が存在する場合
                if (json.errorMessage && json.downloadMaxCount) {

                  // ダウンロード上限超過のエラーメッセージを表示
                  this.$messageIotError(
                    this.$t(
                      'message.common.csvImport.ERR_FILE_EXCEEDED_DOWNLOAD_LIMIT_MSG',
                      { maxCount: json.downloadMaxCount }
                    )
                  );

                  // エラーのため、以降の処理を中断
                  return;
                }
              });

            } else {
              // JSON 以外の場合
              // ファイルダウンロード処理を実行
              fileDownloader(data);
            }

          })
          .finally(() => {
            this.showLoading = false;
          });
        }else{
          this.$refs.download.setAttribute('disabled',true);
        }
      })
    },
    upload() {
      this.$router.push({
        name: "import-page",
        query: {
          type: '03',
          screenIdParam: "M-06-13"
        }
      })
    },
  },
  watch: {
    query: {
      handler() {
        this.query.pageNumber = 1
      },
      deep: true
    }
  },
  mounted() {
    let queryObj = this.$getQueryParam("area_search_id")
    if(queryObj!=null){
      this.query = queryObj
      this.searchArea()
    }
  },
  created() {
    this.$authCheck("010501")
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "",
        title: "label.router.area",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  }
};
</script>

<style lang="scss" scoped>
::v-deep .fm-row .download-btn{
  .my-button{
    color: #525250;
    font-size: 13px;
    background-color: #f7f7f2 !important;
    left: 55px;
    position: relative;
    height: 40px;
    width: 188px;
    text-align: center;
  }
}
.width-text {
  width: 200px;
}
.width-text-360 {
  width: 362px;
}
.text-padding-right {
  padding-right: 20px;
}
.float-right{
  float: right;
}
.float-left{
  float: left;
}
.zdyselect {
  width: 71px;
  height: 24px;
  border-radius: 15px;
}
::v-deep .el-input__suffix {
  top: 0px;
}
::v-deep .el-input__icon {
  line-height: 25px !important;
}
::v-deep .zdyInput {
  .el-input__inner::placeholder {
    color: #B8B8B4;
  }
  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #B8B8B4;
  }
}
::v-deep .el-form-item__content{
  margin-left: 0em !important;
}

.line-height-30{
  line-height: 30px;
}
::v-deep .cancel-width{
  .my-button{
    width: 188px;
    height: 32px;
  }
}

.el-form-item-input{
  ::v-deep .el-input__inner{
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}

.el-col-owner {
  width: 324px;
  margin-right: 16px
}

.el-col-lable-button {
  width: 188px;
}

.row {
  display: flex;
  flex-direction: row;
}

::v-deep .el-form-item__error {
  position: absolute !important;
}

.el-col-width-408 {
  width: 408px;
  //height: 66px;
}

.el-col-width-344 {
  width: 344px;
  height: 50px;
}

.search-form {
  //height: 50px;
  ::v-deep .el-select{
    //margin-top: 10px;
    display: block;
    line-height: 42px;
    width: 188px;
    height: 40px;
    background: #F2F2ED;
    border-radius: 8px;
    overflow: hidden;
    color: #fff;
    box-shadow: -2px -2px 5px #fff,
                  5px 5px 8px #E6E6E1;
    .el-input__inner{
      line-height: 24px;
      color: #525250;
      font-size: 15px !important;
      padding-left: 20px;
    }
    ::placeholder{
        color: #525250;
    }

  }

  ::v-deep .el-input__inner{
    border: none;
    background: #F2F2ED !important;
    color: #525250;
    font-size: 14px !important;
  }
  ::v-deep .el-icon-arrow-up:before {
    color: #525250;
  }
}

::v-deep .zdyselect {
  width: 120px;
  font-size: 15px;
  height: 40px;
  border-radius: 15px;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
  .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}
::v-deep .el-pagination {
  margin-left: -80px;
}

.margin-right-20{
  margin-right: 20px;
}
.margin-bottom-15 {
  margin-bottom: 12px;
}

.label-right{
  position: relative;
  right: 10px;
  font-size: 16px;
}

.limit-length {
   width: 100px !important;
}
</style>
